import { SeatingChart as GQLItem } from '../../generated/graphql';
import { take } from '../../util';

export type SeatingChart = {
  id: number;
  name: string;
};

export const fromGql = (item: GQLItem): SeatingChart => ({
  ...take<SeatingChart>(item, 'id', 'name'),
});
